import { FC, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import * as ErrorMonitor from 'core/ErrorMonitor';

import API, { setAuthToken, resetApiUrl } from 'core/Api';
import AppLoading from 'components/AppLoading';
import { resetStorage } from 'utils/auth';
import { useModal } from 'store/modal';

const LogoutScreen: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const queryClient = useQueryClient();
  const { showModal } = useModal();
  const location = useLocation<{ from?: string; email?: string }>();
  const { state } = location;

  useEffect(() => {
    API.post('auth/logout')
      .then(res => {
        // TODO - edit success message
        showModal({
          type: 'success',
          content: res.data.message,
        });
      })
      .catch(err => {
        // TODO - handle this type of error
        console.error(err);
      })
      .finally(() => {
        logout();
      });
  }, []);

  const logout = () => {
    // Reset Sentry user
    ErrorMonitor.reset();

    // Reset API Auth header
    setAuthToken(null);

    // Reset API base Url in case that operator has been logged in client
    resetApiUrl();

    // Reset storage
    resetStorage();

    // Clear all cached data
    queryClient.removeQueries();

    setIsLoading(false);
  };

  if (isLoading) return <AppLoading />;

  return (
    <Redirect
      to={{
        pathname: '/',
        state,
      }}
    />
  );
};
export default LogoutScreen;
